import React, { ReactNode, useContext } from "react";
import { AccountContext } from "../AccountContext";
import { SorterId } from "../sorting/account-sorting";


export function SortHeader({children, sortId}: {children:ReactNode, sortId: string}){
    const {currentSorter, dispatch} = useContext(AccountContext);

    const isCurrentSorter = currentSorter?.id == sortId

    function toogleSort(){
        if(isCurrentSorter){
            return dispatch({type:"invertSort"});
        }

        dispatch({type:"setSorter", payload: {id: sortId, order: "asc" } as SorterId})
    }


    return <div className="d-flex align-items-center" onClick={toogleSort} style={{cursor:"pointer"}}>
        <div  className="flex-grow-1">{children}</div>
        {isCurrentSorter && <i className={`mx-2 fa ${currentSorter.order == 'desc' ? 'fa-caret-down' : 'fa-caret-up'}`}></i>}
    </div>
}

